<template>
    <div class="cases-listing-table">
				<!-- MAIN STATUS -->
        <b-row class="mb-4 mx-3 filter-buttons">
			<b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'All'"
                    class="mb-2 mr-2 shadow-none bg-dark"
                    @click="filterByStatus('all')"
                >
                    <p class="text-white">All</p>
                    <!-- removed count display -->
                </b-button>
            </b-col>
			<b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'no_status'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('no_status')"
                >
                    <p>No Status</p>
                    <!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'reserve'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('reserve')"
                >
                    <p class="text-dark">Pending Submission</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'bank_processing'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('bank_processing')"
                >
                    <p class="text-dark">Submitted</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'bank_approval'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('bank_approval')"
                >
                    <p class="text-dark">Pending Accept</p>
                    <!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'sold'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('sold')"
                >
                    <p class="text-dark">Acceptance Done</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'completed'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('completed')"
                >
                    <p class="text-dark">Completed</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button
                    block
                    :pressed="selectedButton === 'cancel'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('cancel')"
                >
                    <p class="text-dark">Rejected</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
        </b-row>

        <b-row class="d-flex justify-content-md-between">
            <b-col cols="12">
                <b-row class="d-flex justify-content-end">
                    <b-col cols="12" md="auto" class="float-right text-right">
                        <p>Total SPA Price</p>
                        <h3 class="text-primary font-weight-600">RM {{ _gHlp.getValue(summary,'total.spa_price',0) | moneyFormatter }}</h3>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <PropertyTable :tableData="tableData" :tablePagination="tablePagination" :tableSummary="summary" :tableFilters="tableFilters" ref="propertyTableRef" @onFilter="onFilter($event)"/>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import PropertyTable from '@/views/Cases/CasesTables/Property/PropertyTable'

export default {
    props:['tableData','tablePagination','tableSummary','tableFilters'],
    components: {
        PropertyTable,
				[Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
					summary:{},
					filters:{
						search : {
							prod_pm_main_status:'all'
						}
					},
					selectedButton: 'All',
					selectedSubButton: 'All',
				}
    },
    computed:{
    },
    watch:{
				tableFilters:{
					handler(newVal){
						this.filters = {...this.filters, ...newVal};
					},
					immediate: true
       },    
			 tableSummary:{
					handler(newVal){
						this.summary = newVal;
					},
					immediate: true
       }
    },
    methods: {
				filterByStatus(sts) {
					this.selectedButton = !_gHlp.isEmpty(sts) ? sts : 'All';
					this.filters.search.prod_pm_main_status = sts
					this.filters.is_reset_summary = false
					this.filters.page = 1
					this.$emit('onFilter',this.filters);
        },
				onFilter(event) {
					this.filters = {...this.filters,...event}
          this.$emit('onFilter',this.filters);
				}
        // selectSubButton(button) {
        //     this.selectedSubButton = button;
        //     this.$refs.propertyTableRef.clearEditProduct()
        // },
				// filterSubmit(event) {
        //   this.$emit('filter_submit',event)
        // },
    },
}
</script>